import CitySEOHead from "@/components/feature/CitySEOHead";
import SarasotaHeroSection from "./components/HeroSection";
import SarasotaStickyNav from "./components/StickyNav";
import SarasotaProcessingTimeSection from "./components/ProcessingTimeSection";
import SarasotaServicesSection from "./components/ServicesSection";
import SarasotaLocalAreaSection from "./components/LocalAreaSection";
import SarasotaTestimonialsSection from "./components/TestimonialsSection";
import SarasotaAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import SarasotaComparisonSection from "./components/ComparisonSection";
import SarasotaMistakesSection from "./components/MistakesSection";
import SarasotaHowItWorksSection from "./components/HowItWorksSection";
import SarasotaFAQSection, { faqs } from "./components/FAQSection";
import SarasotaHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import SarasotaFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";
import SarasotaTravelTimingSection from "./components/TravelTimingSection";
import SarasotaDestinationsSection from "./components/DestinationsSection";

const pageUrl = "https://fastpassportcenter.com/cities/sarasota/";
const pageTitle = "Emergency Passport Sarasota, FL — Expedited Same-Day Service | Fast Passport Center";
const pageDescription = "Emergency and expedited passport services in Sarasota, FL — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Sarasota arts travelers, Ringling College students, and Cultural Coast residents.";

const areaServedList = [
  { "@type": "City", "name": "Sarasota" },
  { "@type": "City", "name": "Bradenton" },
  { "@type": "City", "name": "Venice" },
  { "@type": "City", "name": "Lakewood Ranch" },
  { "@type": "City", "name": "Siesta Key" },
  { "@type": "City", "name": "Longboat Key" },
  { "@type": "City", "name": "Lido Key" },
  { "@type": "City", "name": "Nokomis" },
  { "@type": "City", "name": "Englewood" },
  { "@type": "City", "name": "North Port" },
];

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function SarasotaPage() {
  return (
    <>
      <CitySEOHead
        city="Sarasota"
        state="Florida"
        stateAbbr="FL"
        route="/cities/sarasota"
        title={pageTitle}
        description={pageDescription}
        ogTitle={pageTitle}
        ogDescription={pageDescription}
        twitterTitle={pageTitle}
        twitterDescription={pageDescription}
        geoPlacename="Sarasota, Florida"
        geoPosition="27.3364;-82.5307"
        keywords="expedited passport Sarasota, emergency passport Sarasota FL, same day passport Sarasota, fast passport Florida, passport renewal Sarasota, Sarasota passport courier"
        faqs={faqs}
        servicesSchema={servicesList}
        statePageName="Florida"
        statePageRoute="/states/florida"
        lastModified="2026-06-09"
        areaServedList={areaServedList}
        serviceAreaDesc="Fast Passport Center does not have a physical office in Sarasota — we serve this area remotely. Emergency and expedited passport services as fast as 24 hours for Sarasota and Cultural Coast travelers."
      />

      <div className="font-sans">
        <SarasotaHeroSection />
        <SarasotaStickyNav />
        <SarasotaProcessingTimeSection />
        <SarasotaServicesSection />
        <SarasotaLocalAreaSection />
        <SarasotaTravelTimingSection />
        <SarasotaDestinationsSection />
        <SarasotaTestimonialsSection />
        <SarasotaAcceptanceFacilitiesSection />
        <SarasotaComparisonSection />
        <SarasotaMistakesSection />
        <SarasotaHowItWorksSection />
        <SarasotaFAQSection />
        <SarasotaHelpfulResourcesSection />
        <SEOCrossLinks currentRoute="/cities/sarasota" state="FL" />
        <SarasotaFinalCTA />
      </div>
    </>
  );
}